var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-loading",
        {
          attrs: {
            loading: _vm.promoLoaded,
            type: "article"
          }
        },
        [
          _vm.promo.active
            ? _c(
                "v-stepper",
                {
                  attrs: {
                    vertical: ""
                  },
                  model: {
                    value: _vm.currentStep,
                    callback: function callback($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep"
                  }
                },
                [
                  _c("promo-step-one", {
                    attrs: {
                      step: _vm.currentStep
                    },
                    on: {
                      "service-selected": _vm.serviceSelected
                    }
                  }),
                  _c("promo-step-two", {
                    attrs: {
                      step: _vm.currentStep,
                      service: _vm.selectedService
                    },
                    on: {
                      "promo-submitted": _vm.promoSubmitted
                    }
                  }),
                  _c("promo-step-three", {
                    attrs: {
                      step: _vm.currentStep,
                      "promo-request-id": _vm.promoRequestId
                    }
                  })
                ],
                1
              )
            : _c(
                "v-card",
                {
                  staticClass: "app-card"
                },
                [
                  _c("v-card-text", [
                    _c("h2", [_vm._v("Promotion Expired")]),
                    _c("p", [
                      _vm._v(
                        "This promotion has expired. Please contact us if you have any questions."
                      )
                    ])
                  ])
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }